import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_all_device_widgets_gallery';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/**
 * Dev-only virtual dashboard (`/dash/-105`) that lists every home device as
 * Quick Control cards (left) and DashDeviceWidget cards (right).
 * Off by default; enable from the Dev Modal so it does not sit in the dashboard tab rail.
 */
export const allDeviceWidgetsGalleryEnabled = writable<boolean>(readInitialValue());

allDeviceWidgetsGalleryEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isAllDeviceWidgetsGalleryEnabled = (): boolean => get(allDeviceWidgetsGalleryEnabled);

export const setAllDeviceWidgetsGalleryEnabled = (enabled: boolean) => {
	allDeviceWidgetsGalleryEnabled.set(enabled);
};
